const uniqueArray = (arr: any[], key: string = "id") => {
  let uniqueObjArray = [
    ...new Map(arr.map((item) => [item[key], item])).values()
  ]

  return uniqueObjArray
}

export default uniqueArray
